// extracted by mini-css-extract-plugin
export default {"trust":"TrustSection_trust__ZuWAx","content":"TrustSection_content__Ol590","certifications":"TrustSection_certifications__KJJhv","card":"TrustSection_card__kYm-I"};